import { Card } from "../ui/card";

export const ToolsSection = () => {
  const tools = [
    {
      name: "Zapier",
      description: "Connect 5000+ apps and automate workflows with zero-code required. Perfect for businesses of all sizes.",
      image: "/lovable-uploads/62f54598-c428-4301-b4ba-1fbccd33519b.png",
      features: [
        "5000+ app integrations",
        "Visual workflow builder",
        "Automated tasks & triggers",
        "Real-time data sync"
      ]
    },
    {
      name: "Make.com",
      image: "/lovable-uploads/d8cf908d-0858-4e4d-929f-904da4cb3578.png",
      description: "Create complex automation scenarios with a visual workflow builder. Ideal for advanced integration needs.",
      features: [
        "Advanced workflow scenarios",
        "Real-time execution",
        "Data mapping & transformation",
        "Error handling & retries"
      ]
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">
          Powered by Industry-Leading Platforms
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {tools.map((tool) => (
            <Card key={tool.name} className="p-8 hover:shadow-lg transition-shadow">
              <div className="mb-6">
                <div className="h-16 mb-4 flex items-center justify-center">
                  <img
                    src={tool.image}
                    alt={tool.name}
                    className="h-full object-contain"
                  />
                </div>
                <h3 className="text-2xl font-semibold text-center mb-4">{tool.name}</h3>
                <p className="text-gray-600 text-center mb-6">{tool.description}</p>
              </div>
              <ul className="space-y-3">
                {tool.features.map((feature, index) => (
                  <li key={index} className="flex items-center text-gray-700">
                    <svg
                      className="h-5 w-5 text-blue-500 mr-3"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};